import React, { Component, } from 'react';
import {Modal, ModalHeader, ModalBody, Button, Card, CardHeader, CardBody, CardFooter} from 'reactstrap';
import CdnImage from '../../components/cdnImage/cdnImage.js'

var configurationManager = require('../../utils/config/configurationManager.js');
var stringUtil = require('../../utils/string/stringUtil.js');
var translator = require("../../utils/translator/translator");

class CashFloatTypeDialogue extends Component
{
    constructor(props)
    {
        super(props);

        this.onClose = this.onClose.bind(this);
        this.getTypeComponents = this.getTypeComponents.bind(this);
        this.getSubTypeComponents = this.getSubTypeComponents.bind(this);
        this.onOkClick = this.onOkClick.bind(this);
        
        this.state = {};
        this.state.selectedType = null;
        this.state.selectedSubType = null;
    }

    render()
    {
        var okButtonDisabled = false;

        if (this.state.selectedType == null || (this.state.selectedSubType == null && this.state.selectedType.subTypeRequired))
            okButtonDisabled = true;

        return (<Modal isOpen={true} centered animation={false} fade={false} size="lg" style={{maxWidth: '60%', width: '60%'}}>
                    <ModalHeader toggle={this.onClose}>{this.props.title}</ModalHeader>
                    <div style={{margin:'10px'}}>
                        
                        <table style={{width:'100%'}}>
                            <tr>
                                <td style={{width:'50%'}}>
                                    <div style={{height:'60vh', overflowY:'auto'}}>
                                        {this.getTypeComponents()}
                                    </div>
                                </td>
                                <td>
                                    <div style={{marginLeft:'10px', marginRight:'10px', height:'60vh', width:'2px', backgroundColor:'#D0D0D0'}}>
                                    </div>
                                </td>
                                <td style={{width:'50%'}}>
                                    <div style={{height:'60vh', overflowY:'auto'}}>
                                        {this.getSubTypeComponents()}
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td colSpan="3">
                                    <hr/>
                                </td>
                            </tr>

                            <tr>
                                <td colSpan="3" style={{textAlign:'right'}}>
                                    <div>
                                        <Button color="warning" style={{width:'100px', marginRight:'10px'}} onClick={()=>{this.onClose()}}>{translator.getLabel("cancel")}</Button>
                                        <Button color="success" style={{width:'100px'}} disabled={okButtonDisabled} onClick={()=>{this.onOkClick()}}>{translator.getLabel("ok")}</Button>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Modal>);
    }

    getTypeComponents()
    {
        var typeComponents = [];

        this.props.types.forEach (type =>
            {
                const givenType = type;
                var backgroundColor = this.state.selectedType == givenType ? '#F5DEB3' : null;
                typeComponents.push(<Card style={{margin:'0px', backgroundColor:backgroundColor}} onClick={()=>
                                                                                                            {
                                                                                                                if (this.state.selectedType == givenType)
                                                                                                                    return;

                                                                                                                this.state.selectedType = givenType;
                                                                                                                this.state.selectedSubType = null;
                                                                                                                this.setState({});
                                                                                                            }}>
                                        <CardBody>
                                            <table>
                                                <tr>
                                                    <td>
                                                        <div style={{marginLeft:'10px'}}>{givenType.description}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                            
                                        </CardBody>
                                    </Card>);
            });

        return typeComponents;
    }

    getSubTypeComponents()
    {
        if (this.state.selectedType == null)
            return <div className="text-center text-muted" style={{marginTop:'20px'}}>
                        Please choose an option on left side
                    </div>;

        if (this.state.selectedType.SubTypes == null || this.state.selectedType.SubTypes.length <= 0)
        {
            if (this.state.selectedType.subTypeRequired)
                return <div className="text-center text-muted" style={{marginTop:'20px'}}>
                            No Further Selection Available
                        </div>;

            return <div className="text-center text-muted" style={{marginTop:'20px'}}>
                        No Further Selection Required
                    </div>;
        }
            
        var typeSubComponents = [];
        this.state.selectedType.SubTypes.forEach(subType =>
            {
                const givenType = subType;
                var backgroundColor = this.state.selectedSubType == givenType ? '#F5DEB3' : null;
                typeSubComponents.push(<Card style={{margin:'0px', backgroundColor:backgroundColor}} onClick={()=>
                                                                                                            {
                                                                                                                if (this.state.selectedSubType == givenType)
                                                                                                                    return;

                                                                                                                this.state.selectedSubType = givenType;
                                                                                                                this.setState({});
                                                                                                            }}>
                                        <CardBody>
                                            <table>
                                                <tr>
                                                    <td>
                                                        <div style={{marginLeft:'10px'}}>{givenType.description}</div>
                                                    </td>
                                                </tr>
                                            </table>
                                            
                                        </CardBody>
                                    </Card>);
            });

        return typeSubComponents;
    }

    onClose()
    {
       this.props.onClose(false, null, null);
    }

    onOkClick()
    {
        this.props.onClose(true, this.state.selectedType, this.state.selectedSubType);
    }
}

export default CashFloatTypeDialogue;